import { create } from 'zustand'

const store = create((set) => ({
  searchValue: '',
  setSearchValue: (value) => set({ searchValue: value }),
  
  recipes: [],
  setRecipes: (newRecipes) => set((state) => ({ recipes: [...state.recipes, ...newRecipes] })),
  clearRecipes: () => set({ recipes: [] }),
  
  isMenuOpen: false,
  setIsMenuOpen: (value) => set(() => ({ isMenuOpen: value })),
  
  isUserLogged: false, /* must be false!!! */
  setIsUserLogged: (value) => set(() => ({ isUserLogged: value })),
  
  user: {
    id:'x3F4Jkbn09', 
    firstName: 'John', 
    lastName: 'Doe',
    userName: 'Jojo',
    email: 'k@k.com',
    birthDate: '1984-05-02',
    gender: 'male',
    location: 'Paris',
    avatar: '/static/media/lego_avatar_face.png',
    newsletter: true,
    recipes: [{},{},{},{}],
    favorite:[ 3, 5, 6, 9, 10, 13, 14, 15, 16, 17, 19, 21, 27] 
  },
  setUser: (value) => set((state) => ({ 
    user: { ...state.user, ...value } 
  })),

  setFavorite: (id) => set((state) => {
    const isFavorite = state.user.favorite.includes(id)
    const updatedFavorites = isFavorite? 
      state.user.favorite.filter(favId => favId !== id)
      : 
      [...state.user.favorite, id]
    
    return {
      user: {
        ...state.user,
        favorite: updatedFavorites
      }
    }
  })
}))

export default store